import React, { useState, useRef } from "react";
// import { FullPage, Slide } from "react-full-page";
import mainSlide1 from "../../assets/img_slide_01.jpg";
import mainSlide2 from "../../assets/img_slide_02.jpg";
import mainSlide3 from "../../assets/img_slide_03.jpg";
import mainSlide4 from "../../assets/img_slide_04.jpg";

//slide
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

//scroll 애니메이션
import ScrollOut from "scroll-out";
import { useEffect } from "react";

//typeing 애니메이션
import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from "splitting";
import { Link, useNavigate } from "react-router-dom";

import { GetList as GetListBusiness } from "../Business/http";
import { GetList as GetListNotice } from "../../lib/Board";
import moment from "moment";

const Info = () => {
    const slider = useRef();
    const slider2 = useRef();
    const navigate = useNavigate();

    const [itemsBusiness, setItemsBusiness] = useState([]);
    const [itemsNotice, setItemsNotice] = useState([]);

    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        fade: true,
        speed: 1700,
        autoplay: true,
        autoplaySpeed: 5500,
        pauseOnDotsHover: false,
        pauseOnHover: false,
        appendDots: dots => <ul style={{ margin: "0px" }}> {dots} </ul>,
        customPaging: i => <span className="num">{`0${i + 1}`}</span>
    };

    useEffect(() => {
        GetListBusiness(
            {
                page: 1,
                size: 3,
                sort: "-id"
            },
            res => {
                setItemsBusiness(res.rows);
            }
        );

        GetListNotice(
            {
                page: 1,
                size: 4,
                sort: "-id",
                board: "promotion"
            },
            res => {
                setItemsNotice(res.rows);
            }
        );

        Splitting();
        ScrollOut();
    }, []);

    const settings2 = {
        dots: false,
        arrows: false,
        autoplay: true,
        speed: 1200,
        // speed: 500,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    };

    return (
        // <div>
        //     <FullPage controls controlsProps={{ className: "class-name" }}>
        //         <Slide style={{ backgroundColor: "yellow", position: "relative" }}>
        //             <div>내용1</div>
        //         </Slide>
        //         <Slide style={{ backgroundColor: "pink", position: "relative" }}>
        //             <div>내용2</div>
        //         </Slide>
        //         <Slide style={{ backgroundColor: "beige", position: "relative" }}>
        //             <div>내용3</div>
        //         </Slide>
        //     </FullPage>
        // </div>

        <main className="main-contents">
            <section className="main-visual-section">
                <div className="main-slide">
                    <Slider {...settings} ref={slider}>
                        <div className="box">
                            <div className="texts">
                                <h2 style={{ fontSize: 50 }}>고객의 보다 나은 미래를 만드는</h2>
                                <h3 style={{ fontSize: 100 }}>AI 혁신 파트너</h3>
                                <h4>kt MOS북부의 유무선 통신과 AX 역량으로 고객이 필요로 하는 가치를 제공하여 고객의 더 발전된 미래를 만드는데 기여하겠습니다.</h4>
                                {/* <h5>People Technology</h5> */}
                                <button type="button" className="view-more">
                                    VIEW MORE
                                </button>
                            </div>
                            <div className="imgs">
                                <img src={mainSlide1} alt="메인 슬라이드1" />
                            </div>
                        </div>
                        <div className="box">
                            <div className="texts">
                                <h2>SAFE</h2>
                                {/* <h3>
                                    Leading <br />
                                    business innovation
                                </h3> */}
                                <h4>
                                    경영활동 전반에 안전을 최우선 가치로 인식하고, 근로자의 참여를 통해 잠재적 유해.위험요인을 지속적으로 <br />
                                    발굴/개선/제거하고 충분한 인적.물적 자원을 제공할 수 있도록 최선을 다하겠습니다.
                                </h4>
                                {/* <h5>People Technology</h5> */}
                                <button type="button" className="view-more">
                                    VIEW MORE
                                </button>
                            </div>
                            <div className="imgs">
                                <img src={mainSlide2} alt="메인 슬라이드2" />
                            </div>
                        </div>
                        {/* <div className="box">
                            <div className="texts">
                                <h2>5G</h2>
                                <h3>
                                    Leading <br />
                                    business innovation
                                </h3>
                                <h4>고객의 삶의 변화와 다른 사업의 혁신을 리딩하여 대한민국 발전에 기여하는 ktMOS 북부</h4>
                                <h5>People Technology</h5>
                                <button type="button" className="view-more">
                                    VIEW MORE
                                </button>
                            </div>
                            <div className="imgs">
                                <img src={mainSlide3} alt="메인 슬라이드3" />
                            </div>
                        </div>
                        <div className="box">
                            <div className="texts">
                                <h2>5G</h2>
                                <h3>
                                    Leading <br />
                                    business innovation
                                </h3>
                                <h4>고객의 삶의 변화와 다른 사업의 혁신을 리딩하여 대한민국 발전에 기여하는 ktMOS 북부</h4>
                                <h5>People Technology</h5>
                                <button type="button" className="view-more">
                                    VIEW MORE
                                </button>
                            </div>
                            <div className="imgs">
                                <img src={mainSlide4} alt="메인 슬라이드4" />
                            </div>
                        </div> */}
                    </Slider>
                    {/* <div className="play-con">
                        <button
                            type="button"
                            onClick={() => {
                                slider.current.slickPlay();
                            }}
                        >
                            재생
                        </button>
                        <button
                            type="button"
                            onClick={() => {
                                slider.current.slickPause();
                            }}
                        >
                            멈춤
                        </button>
                    </div> */}
                </div>
                <a href="#about-section" className="btn_scrollDown">
                    <span className="txt">SCROLL</span>
                    <span className="icon"></span>
                </a>
            </section>

            <section id="about-section" className="main-about-section">
                <div className="inner" data-scroll>
                    <section className="text_box">
                        <h2 data-splitting="chars">ABOUT US</h2>
                        <h3>
                            최고의 네트워크 <br />
                            서비스 기업
                        </h3>
                        <h4>kt MOS 북부는 KT의 그룹사로서 통신망 인프라를 최상의 상태로 유지∙관리하여 고객에게 최고의 품질을 서비스하고 있는 Network운용 전문회사 입니다.</h4>
                        <div className="slide-btns">
                            <button
                                type="button"
                                className="prev"
                                onClick={() => {
                                    slider2.current.slickPrev();
                                }}
                            >
                                이전
                            </button>
                            <button
                                type="button"
                                className="next"
                                onClick={() => {
                                    slider2.current.slickNext();
                                }}
                            >
                                다음
                            </button>
                        </div>
                    </section>

                    <section className="slide_box">
                        <Slider {...settings2} ref={slider2}>
                            <div>
                                <Link to="/business/major">
                                    <p className="tit">BUSINESS</p>
                                    <p className="kor">사업소개</p>
                                    <p className="icon business"></p>
                                    <p className="explain">
                                        기지국,중계기운용관리,네트워크망관리 <br />
                                        고객케어관리를 수행하고 있습니다.
                                    </p>
                                    <p className="more">+ VIEW MORE</p>
                                </Link>
                            </div>
                            <div>
                                <Link to="/company/history">
                                    <p className="tit">HISTORY</p>
                                    <p className="kor">회사연혁</p>
                                    <p className="icon history"></p>
                                    <p className="explain">
                                        15년동안 고객에게 최고의 <br />
                                        품질서비스를 제공하고 있습니다.
                                    </p>
                                    <p className="more">+ VIEW MORE</p>
                                </Link>
                            </div>
                            <div>
                                <Link to="/recruit/person">
                                    <p className="tit">RECRUIT</p>
                                    <p className="kor">인재채용</p>
                                    <p className="icon recruit"></p>
                                    <p className="explain">
                                        kt MOS 북부에서는 열정적인 <br />
                                        인재를 모십니다.
                                    </p>
                                    <p className="more">+ VIEW MORE</p>
                                </Link>
                            </div>
                            <div>
                                <Link to="/company/direction">
                                    <p className="tit">LOCATION</p>
                                    <p className="kor">찾아오시는 길</p>
                                    <p className="icon location"></p>
                                    <p className="explain">
                                        kt MOS 본사 및 지역본부 <br />
                                        위치 안내입니다.
                                    </p>
                                    <p className="more">+ VIEW MORE</p>
                                </Link>
                            </div>
                        </Slider>
                    </section>
                </div>
            </section>

            <section className="main-notice-section">
                <div className="inner">
                    <section className="notice-box" data-scroll>
                        <h2>
                            공지사항 <b data-splitting="chars">NOTICE</b>
                        </h2>
                        <button
                            type="button"
                            className="btn_more"
                            onClick={() => {
                                navigate("/promotion/board/list", { replace: true });
                            }}
                        >
                            더보기
                        </button>
                        <ul className="list">
                            {itemsNotice.map(x => {
                                return (
                                    <li>
                                        <Link to={"/promotion/board/info/promotion/" + x.id}>
                                            <div className="date">
                                                <p className="day">
                                                    {moment(x.createdAt).format("MM")}.<b>{moment(x.createdAt).format("DD")}</b>
                                                </p>
                                                <p className="year">{moment(x.createdAt).format("YYYY")}</p>
                                            </div>
                                            <div className="detail">
                                                <p className="sbj">{x.title}</p>
                                                {/* <p className="cont">{x.contents.replace(/(<([^>]+)>)/gi, "")}</p> */}
                                                <p className="cont" dangerouslySetInnerHTML={{ __html: x.contents.trim() }}></p>
                                                <p className="more">+ VIEW MORE</p>
                                            </div>
                                        </Link>
                                    </li>
                                );
                            })}
                            {/* <li>
                                <a href="#">
                                    <div className="date">
                                        <p className="day">
                                            10.<b>18</b>
                                        </p>
                                        <p className="year">2022</p>
                                    </div>
                                    <div className="detail">
                                        <p className="sbj">2022년 ktMOS북부 신입/ 경력 채용</p>
                                        <p className="cont">다음과 같이 유능하고 열정있는 인재를 모집합니다. 당사와 미래를 함께 선도해 나갈 분들의 많은 관심과 지원바랍니다. 유능하고 열정있는 인재를 모집합니다.</p>
                                        <p className="more">+ VIEW MORE</p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <div className="date">
                                        <p className="day">
                                            10.<b>18</b>
                                        </p>
                                        <p className="year">2022</p>
                                    </div>
                                    <div className="detail">
                                        <p className="sbj">2022년 ktMOS북부 신입/ 경력 채용</p>
                                        <p className="cont">다음과 같이 유능하고 열정있는 인재를 모집합니다. 당사와 미래를 함께 선도해 나갈 분들의 많은 관심과 지원바랍니다. 유능하고 열정있는 인재를 모집합니다.</p>
                                        <p className="more">+ VIEW MORE</p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <div className="date">
                                        <p className="day">
                                            10.<b>18</b>
                                        </p>
                                        <p className="year">2022</p>
                                    </div>
                                    <div className="detail">
                                        <p className="sbj">2022년 ktMOS북부 신입/ 경력 채용</p>
                                        <p className="cont">다음과 같이 유능하고 열정있는 인재를 모집합니다. 당사와 미래를 함께 선도해 나갈 분들의 많은 관심과 지원바랍니다. 유능하고 열정있는 인재를 모집합니다.</p>
                                        <p className="more">+ VIEW MORE</p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <div className="date">
                                        <p className="day">
                                            10.<b>18</b>
                                        </p>
                                        <p className="year">2022</p>
                                    </div>
                                    <div className="detail">
                                        <p className="sbj">2022년 ktMOS북부 신입/ 경력 채용</p>
                                        <p className="cont">다음과 같이 유능하고 열정있는 인재를 모집합니다. 당사와 미래를 함께 선도해 나갈 분들의 많은 관심과 지원바랍니다. 유능하고 열정있는 인재를 모집합니다.</p>
                                        <p className="more">+ VIEW MORE</p>
                                    </div>
                                </a>
                            </li> */}
                        </ul>
                    </section>

                    <section className="result-box" data-scroll>
                        <h2>
                            사업실적 <b data-splitting="chars">RESULTS</b>
                        </h2>
                        <button
                            type="button"
                            className="btn_more"
                            onClick={() => {
                                navigate("/business/result", { replace: true });
                            }}
                        >
                            더보기
                        </button>
                        <ul className="list">
                            {itemsBusiness.map(x => {
                                return (
                                    <li>
                                        <p className="sbj">{x.title}</p>
                                        <p className="during">
                                            <b>사업기간 ㅣ</b> {x.date}
                                        </p>
                                        <p className="client" dangerouslySetInnerHTML={{ __html: "<b>발주처 ㅣ</b> " + x.order }}>
                                            {/* <b>발주처 ㅣ</b> */}
                                        </p>
                                    </li>
                                );
                            })}
                            {/* <li>
                                <a href="#">
                                    <p className="sbj">평창동계올림픽 Mobile 및 WiFi 운영</p>
                                    <p className="during">
                                        <b>사업기간 ㅣ</b> 2017년 ~ 2018년
                                    </p>
                                    <p className="client">
                                        <b>발주처 ㅣ</b> ㈜케이티
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <p className="sbj">평창동계올림픽 Mobile 및 WiFi 운영</p>
                                    <p className="during">
                                        <b>사업기간 ㅣ</b> 2017년 ~ 2018년
                                    </p>
                                    <p className="client">
                                        <b>발주처 ㅣ</b> ㈜케이티
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <p className="sbj">평창동계올림픽 Mobile 및 WiFi 운영</p>
                                    <p className="during">
                                        <b>사업기간 ㅣ</b> 2017년 ~ 2018년
                                    </p>
                                    <p className="client">
                                        <b>발주처 ㅣ</b> ㈜케이티
                                    </p>
                                </a>
                            </li> */}
                        </ul>
                    </section>
                </div>
            </section>
        </main>
    );
};

// const controlsProps = {
//     style: {
//         left: "50%",
//         paddingTop: "10px",
//         position: "fixed",
//         transform: "translateX(-50%)",
//         scrollMode: "normal",
//     }
// };

export default Info;
